<template>
  <div class="topbar-item quick-user-topbar-item">
    <div
      class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg quick-user-trigger"
      id="kt_quick_user_toggle"
    >
      <span class="quick-user-avatar-frame">
        <img
          :src="userPhoto"
          :alt="`Foto ${userName}`"
          @error="useDefaultAvatar"
        >
        <i class="quick-user-status" aria-label="Aktif"></i>
      </span>
      <span class="quick-user-identity d-none d-md-flex">
        <strong class="quick-user-name">{{ userName }}</strong>
        <span class="quick-user-role">{{ userRole }}</span>
      </span>
      <i class="fas fa-chevron-down quick-user-chevron d-none d-lg-inline" aria-hidden="true"></i>
    </div>

    <div
      id="kt_quick_user"
      ref="kt_quick_user"
      class="offcanvas offcanvas-right account-drawer"
    >
      <div class="account-drawer__header">
        <div>
          <span class="account-drawer__eyebrow">Account Center</span>
          <h3>Profil</h3>
        </div>
        <a
          href="#"
          class="account-drawer__close"
          id="kt_quick_user_close"
          aria-label="Tutup panel profil"
        >
          <i class="fas fa-times" aria-hidden="true"></i>
        </a>
      </div>

      <perfect-scrollbar
        class="account-drawer__content scroll"
      >
        <section class="account-profile-card">
          <div class="account-profile-card__avatar">
            <div class="account-profile-card__avatar-frame">
              <img
                :src="userPhoto"
                :alt="`Foto ${userName}`"
                @error="useDefaultAvatar"
              >
            </div>
            <i class="account-profile-card__status" aria-label="Aktif"></i>
          </div>
          <div class="account-profile-card__body">
            <router-link
              to="/profile/show"
              class="account-profile-card__name"
              @click.native="closeOffcanvas"
            >
              {{ userName }}
            </router-link>
            <span class="account-profile-card__role">{{ userRole }}</span>
            <span class="account-profile-card__email">
              <i class="far fa-envelope" aria-hidden="true"></i>
              {{ userEmail }}
            </span>
            <span class="account-profile-card__active">
              <i aria-hidden="true"></i> Akun aktif
            </span>
          </div>
        </section>

        <nav class="account-nav" aria-label="Navigasi akun">
          <router-link
            to="/profile/show"
            @click.native="closeOffcanvas"
            class="account-nav__item"
          >
            <span class="account-nav__icon"><i class="far fa-user"></i></span>
            <span class="account-nav__text">
              <strong>Profil Saya</strong>
              <small>Data pribadi dan foto profil</small>
            </span>
            <i class="fas fa-chevron-right account-nav__arrow"></i>
          </router-link>

          <router-link
            to="/profile/security"
            @click.native="closeOffcanvas"
            class="account-nav__item"
          >
            <span class="account-nav__icon"><i class="fas fa-shield-alt"></i></span>
            <span class="account-nav__text">
              <strong>Keamanan &amp; Akun</strong>
              <small>Password dan keamanan akses</small>
            </span>
            <i class="fas fa-chevron-right account-nav__arrow"></i>
          </router-link>

          <router-link
            to="/appointment/list/0"
            @click.native="closeOffcanvas"
            class="account-nav__item"
          >
            <span class="account-nav__icon"><i class="far fa-clipboard"></i></span>
            <span class="account-nav__text">
              <strong>Aktivitas</strong>
              <small>Riwayat perjanjian dan pelayanan</small>
            </span>
            <i class="fas fa-chevron-right account-nav__arrow"></i>
          </router-link>
        </nav>

        <section v-if="items.length" class="account-announcements">
          <div class="account-section-heading">
            <div>
              <span>Informasi</span>
              <h4>Pengumuman terkini</h4>
            </div>
            <span class="account-section-heading__count">{{ items.length }}</span>
          </div>
          <button
            v-for="(item, i) in items"
            :key="i"
            type="button"
            class="account-announcement"
            @click="showModal(item.id)"
          >
            <span class="account-announcement__icon">
              <i class="fas fa-bullhorn" aria-hidden="true"></i>
            </span>
            <span class="account-announcement__title">{{ item.title }}</span>
            <i class="fas fa-chevron-right account-announcement__arrow" aria-hidden="true"></i>
          </button>
        </section>
      </perfect-scrollbar>

      <footer class="account-drawer__footer">
        <button type="button" class="account-logout" @click="onLogout">
          <span><i class="fas fa-sign-out-alt" aria-hidden="true"></i></span>
          <span>
            <strong>Keluar dari akun</strong>
            <small>Akhiri sesi dengan aman</small>
          </span>
        </button>
      </footer>

      <b-modal ref="my-modal" size="lg" hide-footer :title="detailAnnouncement.title">
        <div class="d-block text-center">
          <img v-if="detailAnnouncement.image" :src="detailAnnouncement.image" width="500" class="mb-10">
          <div class="mt-10" v-html="detailAnnouncement.content"></div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.topbar-item.quick-user-topbar-item {
  width: auto !important;
  min-width: 0 !important;
  height: auto !important;
  min-height: 0 !important;
  padding: 0 !important;
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

#kt_quick_user_toggle,
#kt_quick_user_toggle:hover,
#kt_quick_user_toggle:focus,
#kt_quick_user_toggle:active {
  width: auto !important;
  min-width: 0 !important;
  color: #ffffff !important;
  min-height: 44px !important;
  padding: 4px 9px 4px 5px !important;
  gap: 9px;
  background: transparent !important;
  border: 0 !important;
  border-radius: 14px !important;
  outline: 0 !important;
  box-shadow: 0 4px 12px rgba(var(--skin-deep-rgb), 0.1) !important;
  transition: background-color 0.2s ease, border-color 0.2s ease,
    box-shadow 0.2s ease, transform 0.2s ease !important;
}

#kt_quick_user_toggle:hover,
#kt_quick_user_toggle:focus {
  background: transparent !important;
  box-shadow: 0 6px 16px rgba(var(--skin-deep-rgb), 0.16) !important;
  transform: translateY(-1px);
}

.quick-user-name {
  display: block;
  max-width: 155px;
  overflow: hidden;
  color: #ffffff !important;
  font-size: 0.975rem;
  font-weight: 700;
  line-height: 1.15;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.quick-user-identity {
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.quick-user-role {
  display: block;
  max-width: 155px;
  margin-top: 2px;
  overflow: hidden;
  color: rgba(223, 255, 249, 0.78) !important;
  font-size: 0.7625rem;
  font-weight: 500;
  line-height: 1.1;
  letter-spacing: 0.02em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.quick-user-avatar-frame {
  position: relative;
  display: block;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  overflow: visible;
  background: #ffffff;
  border: 2px solid rgba(255, 255, 255, 0.92);
  border-radius: 11px;
  box-shadow: 0 4px 12px rgba(var(--skin-deep-rgb), 0.2);
}

.quick-user-avatar-frame img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 9px;
}

.quick-user-status {
  position: absolute;
  right: -3px;
  bottom: -2px;
  width: 9px;
  height: 9px;
  background: #64e6bb;
  border: 2px solid var(--skin-primary);
  border-radius: 50%;
  box-shadow: 0 0 0 2px rgba(100, 230, 187, 0.14);
}

.quick-user-chevron {
  margin-left: 2px;
  color: rgba(255, 255, 255, 0.68) !important;
  font-size: 0.58rem;
}

#kt_quick_user {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100vh !important;
  max-height: 100vh !important;
  padding: 0 !important;
  color: #24364b;
  background: #f8fafc !important;
  z-index: 1100 !important;
}

.account-drawer__header {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  padding: 24px 24px 18px;
  background: #ffffff;
  border-bottom: 1px solid #e7edf3;

  h3 {
    margin: 2px 0 0;
    color: #183153;
    font-size: 1.6rem;
    font-weight: 800;
    letter-spacing: -0.02em;
  }
}

.account-drawer__eyebrow {
  color: var(--skin-secondary);
  font-size: 0.775rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.account-drawer__close {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  color: #6f8196;
  background: #f3f6f9;
  border: 0;
  border-radius: 11px;
  box-shadow: 0 5px 14px rgba(var(--skin-deep-rgb), 0.08);
  transition: color 0.18s ease, background-color 0.18s ease,
    transform 0.18s ease;

  i {
    font-size: 1.25rem;
  }

  &:hover,
  &:focus {
    color: var(--skin-deep);
    background: #e7eef5;
    outline: none;
    transform: translateY(-1px);
  }
}

.account-drawer__content {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  padding: 20px 22px 24px;
}

.account-profile-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 18px;
  overflow: hidden;
  background:
    radial-gradient(circle at 92% 0, rgba(var(--skin-secondary-rgb), 0.2), transparent 42%),
    linear-gradient(135deg, #ffffff 0%, var(--skin-soft) 100%);
  border: 1px solid var(--skin-line);
  border-radius: 16px;
  box-shadow: 0 10px 26px rgba(var(--skin-deep-rgb), 0.07);
}

.account-profile-card__avatar {
  position: relative;
  flex: 0 0 62px;
}

.account-profile-card__avatar-frame {
  width: 62px;
  height: 62px;
  padding: 3px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid rgba(var(--skin-primary-rgb), 0.12);
  border-radius: 18px;
  box-shadow: 0 8px 20px rgba(var(--skin-deep-rgb), 0.12);

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 14px;
  }
}

.account-profile-card__status {
  position: absolute;
  right: -3px;
  bottom: -3px;
  width: 14px;
  height: 14px;
  background: #27c58b;
  border: 3px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0 0 0 2px rgba(39, 197, 139, 0.14);
}

.account-profile-card__body {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}

.account-profile-card__name {
  overflow: hidden;
  color: #183153;
  font-size: 1.15rem;
  font-weight: 800;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    color: var(--skin-primary);
  }
}

.account-profile-card__role {
  margin-top: 2px;
  color: #5f7287;
  font-size: 0.875rem;
  font-weight: 600;
}

.account-profile-card__email {
  display: flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  margin-top: 6px;
  overflow: hidden;
  color: #718399;
  font-size: 0.825rem;
  text-overflow: ellipsis;
  white-space: nowrap;

  i {
    flex-shrink: 0;
    color: var(--skin-secondary);
  }
}

.account-profile-card__active {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 5px;
  margin-top: 8px;
  padding: 3px 8px;
  color: #14785f;
  font-size: 0.725rem;
  font-weight: 800;
  background: rgba(39, 197, 139, 0.11);
  border-radius: 50rem;
  text-transform: uppercase;

  i {
    width: 5px;
    height: 5px;
    background: #27c58b;
    border-radius: 50%;
  }
}

.account-nav {
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin-top: 20px;
}

.account-nav__item {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 62px;
  padding: 10px 12px;
  color: #263b55;
  background: #ffffff;
  border: 1px solid #e5ebf1;
  border-radius: 13px;
  transition: border-color 0.18s ease, box-shadow 0.18s ease,
    transform 0.18s ease;

  &:hover,
  &:focus {
    color: var(--skin-deep);
    border-color: rgba(var(--skin-secondary-rgb), 0.34);
    box-shadow: 0 8px 18px rgba(var(--skin-deep-rgb), 0.07);
    outline: none;
    transform: translateY(-1px);
  }
}

.account-nav__icon {
  display: grid;
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  place-items: center;
  color: var(--skin-primary);
  background: var(--skin-soft);
  border-radius: 11px;
}

.account-nav__text {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;

  strong {
    font-size: 0.95rem;
    font-weight: 800;
  }

  small {
    margin-top: 2px;
    overflow: hidden;
    color: #78899b;
    font-size: 0.8rem;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.account-nav__arrow,
.account-announcement__arrow {
  color: #9aabba;
  font-size: 0.775rem;
}

.account-announcements {
  margin-top: 25px;
  padding-top: 20px;
  border-top: 1px dashed #dbe4ec;
}

.account-section-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  span:first-child {
    color: var(--skin-secondary);
    font-size: 0.7rem;
    font-weight: 800;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }

  h4 {
    margin: 2px 0 0;
    color: #24364b;
    font-size: 1.125rem;
    font-weight: 800;
  }
}

.account-section-heading__count {
  display: grid;
  min-width: 25px;
  height: 25px;
  padding: 0 7px;
  place-items: center;
  color: var(--skin-primary) !important;
  font-size: 0.775rem !important;
  background: var(--skin-soft);
  border-radius: 50rem;
}

.account-announcement {
  display: flex;
  align-items: center;
  gap: 11px;
  width: 100%;
  min-height: 58px;
  padding: 10px 12px;
  color: #294056;
  text-align: left;
  background: var(--skin-soft);
  border: 1px solid var(--skin-line);
  border-radius: 13px;
  cursor: pointer;

  & + & {
    margin-top: 7px;
  }

  &:hover,
  &:focus {
    background: rgba(var(--skin-primary-rgb), 0.12);
    border-color: rgba(var(--skin-primary-rgb), 0.28);
    outline: none;
  }
}

.account-announcement__icon {
  display: grid;
  flex: 0 0 34px;
  width: 34px;
  height: 34px;
  place-items: center;
  color: var(--skin-secondary);
  background: #ffffff;
  border-radius: 10px;
}

.account-announcement__title {
  flex: 1;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.35;
}

.account-drawer__footer {
  flex: 0 0 auto;
  padding: 14px 22px 20px;
  background: #ffffff;
  border-top: 1px solid #e7edf3;
}

.account-logout {
  display: flex;
  align-items: center;
  gap: 11px;
  width: 100%;
  padding: 10px 12px;
  color: #c53e49;
  text-align: left;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 12px;
  cursor: pointer;

  > span:first-child {
    display: grid;
    flex: 0 0 36px;
    width: 36px;
    height: 36px;
    place-items: center;
    background: #fff0f1;
    border-radius: 10px;
  }

  > span:last-child {
    display: flex;
    flex-direction: column;
  }

  strong {
    font-size: 0.9rem;
    font-weight: 800;
  }

  small {
    margin-top: 2px;
    color: #9b6b72;
    font-size: 0.7625rem;
  }

  &:hover,
  &:focus {
    background: #fff7f7;
    border-color: #f4d8db;
    outline: none;
  }
}

@media (max-width: 575px) {
  .account-drawer__header {
    padding: 20px 18px 16px;
  }

  .account-drawer__content {
    padding: 17px 16px 20px;
  }

  .account-drawer__footer {
    padding: 12px 16px 16px;
  }
}
</style>

<script>

import { LOGOUT } from "@/core/services/store/auth.module"
import { mapGetters } from 'vuex'
import KTLayoutQuickUser from "@/assets/js/layout/extended/quick-user.js"
import KTOffcanvas from "@/assets/js/components/offcanvas.js"
import module from '@/core/modules/CrudModule.js'

export default {

  name: "KTQuickUser",

  data() {
    return {
      items: [],
      detailAnnouncement: [],
    };
  },

  mounted() {
    // Init Quick User Panel
    KTLayoutQuickUser.init(this.$refs["kt_quick_user"])
    this.getAnnouncement()

    this.$root.$on("updateAnnouncements", () => {
      this.getAnnouncement()
    });
  },

  computed: {
    ...mapGetters(["currentUserPersonalInfo"]),
    userName() {
      return (this.currentUserPersonalInfo && this.currentUserPersonalInfo.name) || "Pengguna Medhop"
    },
    userRole() {
      const user = this.currentUserPersonalInfo || {}
      return user.position_name ||
        user.job ||
        user.user_type_name ||
        user.polyclinic_name ||
        user.department_name ||
        "Pengguna Klinik"
    },
    userPhoto() {
      const photo = this.currentUserPersonalInfo && this.currentUserPersonalInfo.photo
      if (!photo) return "/media/users/user-default.svg"
      return /^(https?:|data:|\/)/.test(photo) ? photo : `/${photo}`
    },
    userEmail() {
      return (this.currentUserPersonalInfo && this.currentUserPersonalInfo.email) || "Email belum tersedia"
    },
  },

  methods: {
    useDefaultAvatar(event) {
      if (event.target.src.indexOf("user-default.svg") !== -1) return
      event.target.onerror = null
      event.target.src = "/media/users/user-default.svg"
    },

   async getAnnouncement(){
      let response = await module.paginate('announcements/get-shows')
      this.items = (response && response.data && Array.isArray(response.data)) ? response.data : []
    },
    onLogout() {
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
    },
    closeOffcanvas() {
      new KTOffcanvas(KTLayoutQuickUser.getElement()).hide();
    },
   async showModal(id) {
     this.detailAnnouncement = await module.get('announcements/' + id)
        this.$refs['my-modal'].show()
    },
    hideModal() {
        this.$refs['my-modal'].hide()
    },
  },

};
</script>
